import styled from 'styled-components';

export const Container = styled.div`
  width: 292px;
  box-sizing: border-box;
`;

export const Carousel = styled.div<{ isDisabled?: boolean }>`
  user-select: none;
  width: 100%;
  height: 212px;
  position: relative;
  padding: 8px;
  box-sizing: border-box;
  background: ${({ theme: { color } }) => color.ui5};
  border-radius: ${({ theme: { radius } }) => radius.xs};
  border: 1px solid ${({ theme: { color } }) => color.ui4};
  box-shadow: ${({ theme: { shadows } }) => shadows.standByShadow};

  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};
  pointer-events: ${({ isDisabled }) => (isDisabled ? 'none' : 'auto')};

  /* Carousel */
  display: flex;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }
`;
export const Thumbnail = styled.img`
  scroll-snap-align: start;
  min-width: 292px;
  height: 100%;
  object-fit: contain;
  pointer-events: none;
`;

export const Button = styled.button<{ direction: 'left' | 'right' }>`
  position: sticky;
  fill: ${({ theme: { color } }) => color.s1};
  top: 50%;
  transform: translateY(-50%);
  /*  NOTE(omer): This 244 is calculated from 292px(width of carousel) - 16px padding(8px left + 8px right) - 28px(width of button) - 4px(margin for button) */
  left: ${({ direction }) => (direction === 'left' ? '0px' : '244px')};

  background: ${({ theme: { color } }) => color.ui5};
  border: none;
  margin: 0;
  padding: 0;
  min-width: 28px;
  min-height: 28px;
  width: 28px;
  height: 28px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 100ms all;
  cursor: pointer;

  &:hover {
    filter: brightness(1.05);
  }
  & > * {
    transform: ${({ direction }) =>
      direction === 'left' ? 'translateX(-1px)' : 'translateX(1px)'};
  }
`;
